"use strict";

angular.module('rmContact')
    .config(['$stateProvider', function ($stateProvider) {

        $stateProvider
            .state('contacts', {
                url: "/contacts",

                views: {

                    'contactoverview': {

                        templateUrl: '/partial/app.partials.contact.overview',
                        controller: 'ContactOverviewCtrl',
                        controllerAs: 'contactCtrl'
                    },
                    'contactdetail': {

                        templateUrl: '/partial/app.panels.empty'
                    }
                },

                onEnter: ['bladesManager', function (bladesManager) {

                    bladesManager.clearAll();
                    bladesManager.insert({viewName: 'contactoverview', size: 'half'});
                    bladesManager.insert({viewName: 'contactdetail', size: 'half'});
                }],

                resolve: {

                    itemFilters: ['$http', function ($http) {

                        return $http.get('/usersettings').then((req) => {

                            return req.data.item_filter;
                        });
                    }],

                    filterMap: ['$http', function ($http) {

                        return $http.get('/userfilters/contact').then((req) => {

                            return req.data.userFilters;
                        });
                    }]
                }
            }).state('contacts.create', {
            url: "/create",
            views: {

                'contactdetail@': {

                    templateUrl: '/partial/app.partials.contact.detail',
                    controller: 'ContactFormCtrl',
                    controllerAs: 'contactCtrl'
                }
            }
        }).state('contacts.update', {
            url: "/update/:contactId",
            views: {

                'contactdetail@': {

                    templateUrl: '/partial/app.partials.contact.detail',
                    controller: 'ContactFormCtrl',
                    controllerAs: 'contactCtrl'
                }
            }
        });
    }]);
